import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import Icon from "../../components/Icon"

export const FooterStyled = styled.footer`
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 50px;
    background: ${({ theme }) => theme.whiteTwo};
    box-shadow: 0px -2px 8px 0px rgba(144,164,183,0.3);
    z-index: 1;
`

export const FooterContent = styled.div`
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`

export const NavLinkStyled = styled(NavLink)`
    text-decoration: none;
    color: ${({ theme }) => theme.brownGrey};
    font-size: 14px;
    &.active {
        color: ${({ theme }) => theme.greyishBrown};
    }
`
export const StyledFooterItemWrapper = styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-right: 1px solid ${({ theme }) => theme.veryLightPink};
    &:last-of-type {
        border-right: none;
    }
`

export const StyledFooterItem = styled.div`
    position: relative;
    width: 100%;
`

export const IconStyled = styled(Icon).attrs(props => ({
    color: props.active ? props.theme.grassyGreen : props.theme.brownGrey,
    height: 34
}))``

export const StyledIconAlert = styled(Icon).attrs(props => ({
    height: 20,
    width: 20
}))`
    position: absolute;
    top: 0;
    right: -10px;
`